module.exports = __webpack_public_path__ + "img/download.fa0c2965.svg";